import angular from 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { UserflowInitializerComponent } from './userflow.initializer.component';

angular.module('app-lite.userflow', [])
.directive('worUserflowInitializer', downgradeComponent({ component: UserflowInitializerComponent }));
